import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { InformativeMessagesFailure, InformativeMessagesRequest, InformativeMessagesSuccess } from './actions';
import { InformativeMessage } from '@models/swagger';
import { InformativeMessagesParams, InformativeMessagesService } from './service';

@Injectable()
export class InformativeMessagesEffects {
  private readonly actions$ = inject(Actions);
  private readonly informativeMessagesService = inject(InformativeMessagesService);

  informativeMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InformativeMessagesRequest),
      switchMap(({ parameters }: { parameters?: InformativeMessagesParams }) =>
        this.informativeMessagesService.informativeMessages(parameters).pipe(
          map((data: InformativeMessage[]) => InformativeMessagesSuccess({ data })),
          catchError(error => of(InformativeMessagesFailure({ error })))
        )
      )
    )
  );

}
